<div class="row">
    <div class="col-6">
        <h1>Contratos</h1>
    </div>
    <div class="col-6 ">
      <div style="text-align: right">
        <button type="button" class="btn btn-primary" routerLink="/quotation">
            + Crear contrato
        </button>
      </div>
    </div>
</div>


<!--app-add-company-->
<div class="row">
    <div class="col-md-12">
        <div class="card">
            <div class="card-body">
              <div class="row" style="margin-bottom: 15px;">
                <div class="col-md-12">
                  <!-- <div class="dropdown">
                    <button class="btn btn-secondary dropdown-toggle" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                      Reportes
                    </button>
                    <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                      <a class="dropdown-item" href="javascript:void(0)" (click)="exportFilteredAsXLSX()">Contratos Pagados</a>
                    </div>
                  </div>
                   -->
                </div>
              </div>

              <div *ngIf="contracts">
                <!-- <p style="padding-left: 6px"><input type="checkbox" (click)="showCanceled($event)"> Ver cancelados   <input type="checkbox" (click)="showCanceled($event)"> Ver solo pagados</p> -->                
                <table style="width: 100%;" datatable [dtOptions]="dtOptions" class="table" id="dataTable">
                    <thead>
                      <tr>
                        <th scope="col">Contrato</th>
                        <th scope="col">Tipo</th>
                        <th scope="col">Agencia</th>
                        <th scope="col">Póliza(s)</th>
                        <th scope="col">Cliente</th>
                        <th scope="col">Fecha</th>
                        <th scope="col">Productor</th>
                        <th scope="col">Prima</th>
                        <th scope="col">Status</th>
                        <th scope="col"></th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr *ngFor="let contract of contracts">
                        <td>{{ contract.contractName }}</td>
                        <td>{{ contract.contractType }}</td>
                        <td>{{ contract.agencyName }}</td>
                        <td>
                          <div *ngFor="let pol of contract.policyNumbers">
                            {{ pol }}<br>
                          </div>
                        </td>
                        <td>{{ contract.customerName }}</td>
                        <td>{{ contract.formalizationDate | date:'shortDate' }}</td>
                        <td>{{ contract.producerName }}</td>
                        <td>{{ contract.totalPremium }}</td>
                        <td>
                          <span *ngIf="contract.status.toLowerCase() === 'cancel'.toLowerCase()"
                                style="background-color: #ad3636; color: #fff; padding: 4px 10px; border-radius: 12px; font-size: 0.85em;">
                            Cancel
                          </span>
                          <span *ngIf="contract.status.toLowerCase() === 'Void'.toLowerCase()"
                                style="background-color: #818181; color: #fff; padding: 4px 10px; border-radius: 12px; font-size: 0.85em;">
                            Void
                          </span>
                          <span *ngIf="contract.status.toLowerCase() === 'Declined'.toLowerCase()"
                                style="background-color: #ad3636; color: #fff; padding: 4px 10px; border-radius: 12px; font-size: 0.85em;">
                            Declined
                          </span>
                          <span *ngIf="contract.status.toLowerCase() === 'quotation'.toLowerCase()"
                                style="background-color: #b7b034; color: #fff; padding: 4px 10px; border-radius: 12px; font-size: 0.85em;">
                            Quotation
                          </span>
                          <span *ngIf="contract.status.toLowerCase() === 'pending'.toLowerCase()"
                                style="background-color: #a17333; color: #fff; padding: 4px 10px; border-radius: 12px; font-size: 0.85em;">
                            Pending
                          </span>
                          <span *ngIf="contract.status.toLowerCase() === 'approved'.toLowerCase()"
                                style="background-color: #448944; color: #fff; padding: 4px 10px; border-radius: 12px; font-size: 0.85em;">
                            Approved
                          </span>
                          <span *ngIf="contract.status && !['cancel','approved','pending','quotation','Declined', 'Void'].includes(contract.status.toLowerCase())">
                            {{ contract.status || '' }}
                          </span>
                        </td>
                        <td>
                          <button *ngIf="(contract.status || '').toLowerCase() === 'quotation'" type="button" (click)="fileInput.click()" class="btn btn-primary" style="margin-right: 10px; margin-bottom: 10px;">Upload</button>
                          <input #fileInput type="file" hidden (change)="onContractFileSelected($event, contract.id)" />
                          <button type="button" (click)="contractDetails(contract)" class="btn btn-secondary" style="margin-bottom: 10px;">Contrato</button>
                        </td>
                      </tr>
                    </tbody>
                  </table>

                </div>
                
               
                
            </div>
        </div>
    </div>
</div>


<div *ngIf="loading" class="d-flex justify-content-center loading-screen">
  <div class="spinner-border" role="status">
    <span class="sr-only"></span>
  </div>
</div>